import React, {Component} from 'react';
import LogiService from "../LogiService";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {ButtonToolbar, Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import EbusLogiTable from "./components/EbusLogiTable";
import {TopButtonAction, TopButtonPointAction} from "../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import moment from "moment";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";


export default class EbusLogiTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logi: [],
            strona: 1,
            ilosc: 15,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            trwaSzukanie: false,
            zapytanie: "",
            pokazPodpowiedz: false,
            eventy:[],
            typy:[],
            dataOd:moment().add({days:-30}),
            dataDo:moment(),

        };
        this.onSizePerPageList = this.onSizePerPageList.bind(this)
        this.onPageChange = this.onPageChange.bind(this)
    }

    componentDidMount() {
      //  this.pobierzLogi(1, 15);
        this.pobierzEventy();
        this.pobierzTypy();




        let zapytaniedata = "data_wpisu between '"+DateAndTimeFormat.formatYYYYMMDD(moment().add({days:-30}))+"' and '"+DateAndTimeFormat.formatYYYYMMDD(moment())+"'";
        this.setState({zapytanie:zapytaniedata});
        document.getElementById("zapytanieInput").value = zapytaniedata;

        this.onClickSzukajLogow(1,15,zapytaniedata)
    }

    pobierzEventy(){
        LogiService.pobierzSlownikEventowWLogach().then(function (response) {
            this.setState({eventy:response.data})
        }.bind(this))
    }

    pobierzTypy(){
        LogiService.pobierzSlownikTypowWLogach().then(function (response) {
            this.setState({typy:response.data})
        }.bind(this))
    }

    pobierzLogi(strona = this.state.strona, ilosc = this.state.ilosc) {
        this.setState({trwaSzukanie: true})
        LogiService.getLogiEbus(strona - 1, ilosc).then(function (response) {
            this.setState({
                logi: Array.from(response.data.content, item => {
                    return {
                        "data_wpisu": item.dataWpisu,
                        "id_uz": item.idUz,
                        "url": item.url,
                        "metoda": item.metoda,
                        "event": item.event,
                        "typ": item.typ,
                        "klient_ip": item.klientIp,
                        "klient_info": item.klientInfo,
                        "opis": item.opis,
                        "id_ku": item.idKu,
                        "id": item.id,
                        "login": item.login
                    }
                }),
                pageable: {
                    first: response.data.first,
                    last: response.data.last,
                    page: response.data.number,
                    size: response.data.size,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                },
                trwaSzukanie: false
            })
        }.bind(this)).catch(function (err) {
            this.setState({trwaSzukanie: false})
        }.bind(this))
    }

    onSizePerPageList(size) {
        this.setState({ilosc: size})
    }

    onPageChange(page, sizePerPage) {
        this.setState({strona: page})
        if (this.state.zapytanie.length > 0) {
            this.onClickSzukajLogow(page, sizePerPage)
        } else {
            this.pobierzLogi(page, sizePerPage)
        }
    }


    onClickSzukajLogow(strona = this.state.strona, ilosc = this.state.ilosc,zapytanie = this.state.zapytanie) {
        this.setState({
            logi: [],
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            trwaSzukanie: true
        })
        LogiService.szukajLogowEbus(zapytanie, strona - 1, ilosc).then(function (response) {

            this.setState({
                logi: response.data.content,
                pageable: {
                    first: response.data.first,
                    last: response.data.last,
                    page: response.data.number,
                    size: response.data.size,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                },
                trwaSzukanie: false
            })

        }.bind(this))
            .catch(function (error) {
                console.log(error)

                this.setState({trwaSzukanie: false})

            }.bind(this))
    }

    onChangeZapytanie(e) {
        this.setState({zapytanie: e.target.value})
    }

    onClickWyczysc() {
        document.getElementById("zapytanieInput").value = '';
        this.setState({
            logi: [],
            strona: 1,
            ilosc: 15,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            trwaSzukanie: false,
            zapytanie: "",
        })
        this.pobierzLogi(1, 15)
    }


    onClickBudujZapytanie(key,value){
        let zapytanie = this.state.zapytanie;

        if(zapytanie.length>0){
            zapytanie = zapytanie + " and " + key+"='"+value+"'"
        }
        else{
            zapytanie = key+"='"+value+"'"
        }

        this.setState({zapytanie:zapytanie});
        document.getElementById("zapytanieInput").value = zapytanie;
    }

    onChangeData(e,key){
        let zapytaniedata = "";

        if(key==="dataOd"){
            this.setState({dataOd:e})
            zapytaniedata = "data_wpisu between '"+DateAndTimeFormat.formatYYYYMMDD(e)+"' and '"+DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)+"'"
        }
        else{
            this.setState({dataDo:e})
            zapytaniedata = "data_wpisu between '"+DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd)+"' and '"+DateAndTimeFormat.formatYYYYMMDD(e)+"'"
        }

        this.setState({zapytanie:zapytaniedata});
        document.getElementById("zapytanieInput").value = zapytaniedata;
    }

    render() {

        return (
            <div>
                <Col xs={12}>
                    <TopIf isTrue={this.state.trwaSzukanie}>
                        <div id={'GenerowanieContainer'}>
                            <h1>
                                <i className={'fa fa-spinner fa-spin'}></i>
                                <div>
                                    Trwa szukanie rekordów...
                                </div>
                                <h6>
                                    Proces ten może potrwać dłuższą chwilę
                                </h6>
                            </h1>
                        </div>
                    </TopIf>
                </Col>
                <div>
                    <form>
                        <FormGroup>
                            <Col lg={4}>
                                <ControlLabel>
                                    Zapytanie
                                </ControlLabel>
                                <FormControl onChange={(e) => this.onChangeZapytanie(e)} id={"zapytanieInput"}/>
                                <div style={{color: "grey", fontSize: "12px", fontStyle: "italic", marginTop: "5px"}}>
                                    W celu uzyskania odpowiedzi na pytanie "jak korzystać z wyszukiwarki", proszę kliknąć przycisk oznaczony symbolem <i className={"fa fa-info-circle"}></i>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <ControlLabel>
                                    Od daty
                                </ControlLabel>
                                <TopInputDate onChange={(e)=>{this.onChangeData(e,"dataOd")}} value={this.state.dataOd}/>
                            </Col>
                            <Col lg={2}>
                                <ControlLabel>
                                    Do daty
                                </ControlLabel>
                                <TopInputDate onChange={(e)=>{this.onChangeData(e,"dataDo")}} value={this.state.dataDo}/>
                            </Col>
                            <Col lg={3}>
                                <div className={"add-label-margin"}></div>
                                <ButtonToolbar>
                                    <TopButtonAction onClick={() => {
                                        this.onClickSzukajLogow()
                                    }}
                                                     text={"Szukaj w logach"}
                                                     iconType={"fa fa-search"}
                                    />
                                    <TopIf isTrue={this.state.zapytanie.length > 0}>
                                        <TopButtonAction onClick={() => {
                                            this.onClickWyczysc()
                                        }}
                                                         text={"Wyczyść wyszukiwanie"}
                                                         iconType={"fa fa-times"}
                                                         btnColor={"default"}
                                                         elementStyle={{color: "firebrick"}}
                                        />
                                    </TopIf>
                                    <TopButtonPointAction onClick={() => {
                                        this.setState({pokazPodpowiedz: true})
                                    }} titleContent={"Pokaż podpowiedź"} buttonColor={"default"} buttonIcon={"fa fa-info-circle"}/>
                                </ButtonToolbar>
                            </Col>
                        </FormGroup>
                    </form>
                    <div className={"clearfix"}></div>
                    <div>
                        <TopIf isTrue={this.state.pokazPodpowiedz}>
                                <Col lg={8}>
                                    <div className={'thumbnail'} style={{marginTop:"15px", padding: "15px"}}>
                                        <div className={"pull-right"}>
                                            <TopButtonPointAction onClick={() => {
                                                this.setState({pokazPodpowiedz: false})
                                            }} titleContent={"Zamknij podpowiedź"} buttonColor={"default"} buttonIcon={"fa fa-times"}/>
                                        </div>
                                        <div>
                                            <h4>Jak korzystać z wyszukiwarki?</h4>
                                            <p>
                                                Korzystanie z wyszukiwarki opiera się na budowie kryterium zapytania. Należy wybrać pole (bądź pola) wskazane w poniższej liście oraz wprowadzić odpowiedni warunek logiczny. Dozwolone jest użycie operatorów porównania oraz operatorów logicznych:
                                                <ul>
                                                    <li><span style={{fontWeight:"bold", marginRight:"5px"}}>=</span> - wartość jest równa</li>
                                                    <li><span style={{fontWeight:"bold", marginRight:"5px"}}>!=</span> - wartość nie jest równa</li>
                                                    <li><span style={{fontWeight:"bold", marginRight:"5px"}}>&#60;</span> - wartość jest mniejsza</li>
                                                    <li><span style={{fontWeight:"bold", marginRight:"5px"}}>&#60;=</span> - wartość jest mniejsza bądź równa</li>
                                                    <li><span style={{fontWeight:"bold", marginRight:"5px"}}>&#62;</span> - wartość jest większa</li>
                                                    <li><span style={{fontWeight:"bold", marginRight:"5px"}}>&#62;=</span> - wartość jest większa bądź równa</li>
                                                </ul>
                                                Dozwolone jest również łączenie kryteriów słowami <span style={{fontWeight:"bold"}}>and</span> (gdy wszystkie warunki muszą być spełnione) oraz <span style={{fontWeight:"bold"}}>or</span> (gdy wystarczy by jeden warunek był spełniony). W przypadku podawania wartości innych niż id, należy zastosować pojedyńczy cudzysłów: <span style={{fontWeight:"bold"}}>'text'</span> .
                                            </p>
                                            <p style={{marginBottom:"15px"}}>
                                                <strong>Przykłady:</strong>
                                                <ul>
                                                <li>
                                                    id_uz=245 <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>Wyszukuje wszystkie logi wykonane przez użytkownika o id 245</span>
                                                </li>
                                                <li>
                                                    typ='DEBUG' <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>Wyszukuje wszystkie logi typu DEBUG</span>
                                                </li>
                                                <li>
                                                    id_uz=245 and data_wpisu>'2019-09-01' <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>Wyszukuje wszystkie logi wykonane przez użytkownika o id 245 po dniu 1 września 2019</span>
                                                </li>
                                                <li>
                                                    id_uz=245 or id_uz=226 <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>Wyszukuje wszystkie logi wykonane przez użytkownika o id 245 bądź przez użytkownika o id 226</span>
                                                </li>
                                                </ul>

                                            </p>
                                            <Row>
                                                <Col xs={4}>
                                                    <strong style={{marginLeft:"25px"}}>LISTA PÓL <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>zalecane do użycia jako kryterium</span></strong>
                                                    <ul>
                                                        <li>id</li>
                                                        <li>data_wpisu</li>
                                                        <li>url</li>
                                                        <li>typ</li>
                                                        <li>event <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>(zdarzenie)</span></li>
                                                        <li>id_ku <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>(kurs)</span></li>
                                                        <li>login <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>bądź</span> id_uz</li>
                                                    </ul>
                                                </Col>
                                                <Col xs={5}>
                                                    <strong style={{marginLeft:"25px"}}>ZDARZENIA <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>pole event</span> </strong>
                                                    <ul>
                                                        {
                                                            this.state.eventy.map(item=>
                                                                <li style={{cursor:"pointer"}} onClick={()=>{this.onClickBudujZapytanie("event",item)}}>{item}</li>
                                                            )
                                                        }
                                                    </ul>
                                                </Col>
                                                <Col xs={3}>
                                                    <strong style={{marginLeft:"25px"}}>TYPY  <span style={{fontWeight:"normal", color:"grey", fontSize:"12px", fontStyle:"italic"}}>pole typ</span></strong>
                                                    <ul>
                                                        {
                                                            this.state.typy.map(item=>
                                                                <li style={{cursor:"pointer"}} onClick={()=>{this.onClickBudujZapytanie("typ",item)}}>{item}</li>
                                                            )
                                                        }
                                                    </ul>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                        </TopIf>
                    </div>
                    <div className={"clearfix"}></div>
                </div>
                <EbusLogiTable data={this.state.logi}
                               pageable={this.state.pageable}
                               ilosc={this.state.ilosc}
                               strona={this.state.strona}
                               onSizePerPageList={this.onSizePerPageList}
                               onPageChange={this.onPageChange}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/logi/ebusTab/EbusLogiTab.js